/**
 * Marketing analytics helpers. gtag (Google Ads) and Clarity are loaded from public/index.html;
 * everything here is a no-op when they are blocked or absent.
 */
const ADS_ID = 'AW-17945710873';
// Conversion label from Google Ads → Goals → Conversion actions → "Sign up" → Tag setup (AW-…/<label>)
const SIGNUP_LABEL = process.env.REACT_APP_GOOGLE_ADS_SIGNUP_LABEL || '';

const gtag = (...args) => {
  try { if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag(...args); } catch (e) { /* ignore */ }
};

/** Fired once a new organisation has been registered. */
export const trackSignup = ({ method = 'email', plan = 'trial' } = {}) => {
  gtag('event', 'sign_up', { method, plan });
  if (SIGNUP_LABEL) gtag('event', 'conversion', { send_to: `${ADS_ID}/${SIGNUP_LABEL}`, value: 0, currency: 'USD' });
  try { if (typeof window.clarity === 'function') window.clarity('event', 'sign_up'); } catch (e) { /* ignore */ }
};

export const trackEvent = (name, params = {}) => gtag('event', name, params);
